import React, {FC, PropsWithChildren, useState} from "react";
import styles from "./DataPair.module.css";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import {IconButton, Tooltip} from '@mui/material';

export interface DataPairProps extends PropsWithChildren {
    label: string;
    value: string | number | undefined;
    dataId: string;
    copyValue?: string;
    copyLabel?: string;
}

const DataPair: FC<DataPairProps> = (props: DataPairProps) => {
    const [copied, setCopied] = useState(false);

    async function copyToClipboard() {
        if (!props.copyValue) {
            return;
        }

        await window.navigator.clipboard.writeText(props.copyValue);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 1500);
    }

    return <div className={styles.DataPair}>
        <span className={styles.DataLabel}>{props.label}</span>
        <span
            className={props.copyValue ? `${styles.DataValue} ${styles.CopyableValue}` : styles.DataValue}
            data-id={props.dataId}
            onDoubleClick={props.copyValue ? () => void copyToClipboard() : undefined}
            title={props.copyValue ? 'Double-click to copy' : undefined}
        >
            {props.value}
        </span>
        <span className={styles.Actions}>
            {props.copyValue && <Tooltip title={copied ? 'Copied' : (props.copyLabel ?? 'Copy value')}>
                <IconButton
                    size="small"
                    className={styles.CopyButton}
                    aria-label={props.copyLabel ?? 'Copy value'}
                    onClick={() => void copyToClipboard()}
                >
                    {copied ? <CheckIcon fontSize="inherit"/> : <ContentCopyIcon fontSize="inherit"/>}
                </IconButton>
            </Tooltip>}
            {props.children}
        </span>
    </div>
}


export default DataPair;
